import { Tenant } from "./Tenant";
import { Item } from "./item";
import type { VesselPlannerSetting } from "./VesselPlannerSetting";

export class Vessel implements Item {
  public "@id"?: string;

  constructor(
    _id?: string,
    public name?: string,
    public mmsi?: string,
    public euid?: string,
    public tenant?: Tenant[]| string[],
    public linkedVessel?: Vessel[]| string[],
    public plannerSettings?: VesselPlannerSetting,
  ) {
    this["@id"] = _id;
  }
}
